document.addEventListener('DOMContentLoaded', function () {
  const mobileSearch = document.getElementById('mobile-search');
  const searchBar = document.getElementById('search_bar');

  if (mobileSearch && searchBar) {
    mobileSearch.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default anchor behavior
      searchBar.classList.toggle('is-hidden'); // Toggle visibility class
    });
  }
});